module.exports = __webpack_public_path__ + "static/media/LOR_Dr.Decker_BGSU.8dcb92ce.pdf";